<template>
    <div>
        <b-row class="">
            <b-col>
                <b-card>
                    <b-row class="d-flex justify-content-between">
                        <Conversion1></Conversion1>
                        <b-col>
                            <Declines></Declines>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row class="mb-4">
            <b-col cols="12">
                <ProfitReport></ProfitReport>
            </b-col>
        </b-row>

        <b-row class="mb-4">
            <b-col>
                <conversion2></conversion2>
            </b-col>
        </b-row>


        <b-row class="">
            <b-col v-if="hasRoleForQAToPushed()">
                <b-card>
                    <b-row class="d-flex justify-content-between">
                        <QaToOfferGen :load_url="'/dashboards/TimeToOffer/'"></QaToOfferGen>
                    </b-row>
                </b-card>
            </b-col>

            <b-col>
                <b-card>
                    <template v-slot:header>
                        <span class="h6"><i class="fa-duotone fa-file-export mr-1"></i> Ready for Batch Re-class Reports</span>
                    </template>
                    <b-row>
                        <b-col>
                            <b-button variant="secondary" class="mr-2" @click="batchReclassReport()" :disabled="batchUpdating !== false">
                                <i class="fa-solid fa-spinner fa-spin fa-fw" v-if="batchUpdating == 'weekly'"></i>
                                <i class="fa-solid fa-file-arrow-down fa-fw" v-else></i>
                                <strong>Weekly Report: </strong><em>{{ weeklyDate }}</em>
                            </b-button>
                            <b-button variant="primary" @click="batchReclassReport(true)" :disabled="batchUpdating !== false">
                                <i class="fa-solid fa-spinner fa-spin fa-fw" v-if="batchUpdating == 'monthly'"></i>
                                <i class="fa-solid fa-file-arrow-down fa-fw" v-else></i>
                                <strong>Month-end Report: </strong><em>{{ monthEndDate }}</em>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Declines from '../dashboard/widgets/Declines';
import Conversion1 from '../dashboard/data/conversion/Conversion1.vue';
import Conversion2 from '../dashboard/data/conversion/Conversion2Trends.vue';
import ProfitReport from '@/views/dashboard/widgets/ProfitReport';
import QaToOfferGen from '../dashboard/widgets/QaToOfferGen';
import moment from 'moment';

export default {
    name: 'reports',
    components: { QaToOfferGen, Declines, Conversion1, Conversion2, ProfitReport },
    computed: {
        sortedButtonTypes() {
            let pfa = this.buttons.filter(a => a.type == 'pfa');
            let other = this.buttons.filter(a => a.type == 'other');
            return {
                pfa: pfa,
                other: other,
            };
        },
        weeklyDate() {
            return moment().format('MMMM') + ' 1 — Today';
        },
        monthEndDate() {
            return moment().subtract(1, 'month').format('MMMM YYYY');
        },
    },
    methods: {
        hasRoleForQAToPushed() {
            let roles = this.$store.state.user.profile.roles.data;
            let hasRole = roles.some(role => (role.name === 'Super Admin' || role.name === 'B79 Admin'));
            return hasRole;
        },
        batchReclassReport(monthEnd) {
                if (monthEnd) {
                    this.batchUpdating = 'monthly';
                } else {
                    this.batchUpdating = 'weekly';
                }

                this.$http.get(this.$http.defaults.baseURL+'/reports/batch/readyForBatchReport' + (monthEnd ? '/true' : ''), {
                    responseType: 'blob',
                }).then(res => {
                    this.$http.downloadFile(res.data, 'batchReclassReport_' + moment().format('YYYY-MM-DD') + (monthEnd ? '_MonthEnd' : '') + '.xlsx');
                }).finally(() => {
                    this.batchUpdating = false;
                });
            },
    },
    data() {
        return {
            batchUpdating: false,
        };
    }
};
</script>

<style scoped></style>